<template>
    <v-container>
        <v-card>
            <v-card-title>
                <span class="headline">{{ $t('notifySettings')|capitalize }}</span>
            </v-card-title>
            <v-card-text>
                <v-layout align-center justify-center row>
                    <v-flex>
                        <v-layout column>
                            <v-flex class="mb-2">
                                <v-switch v-model="save_user_notify_new_message" v-on:change="updateNotifySetting">
                                    <template v-slot:label>
                                        <div>
                                            {{ $t('notifySettingsNewMessage')|capitalize }}: <strong
                                            :class="save_user_notify_new_message?'success--text':'error--text'">{{$t(save_user_notify_new_message?'on':'off')|capitalize}}</strong>
                                        </div>
                                    </template>
                                </v-switch>
                                <v-switch v-model="save_user_notify_request_support" v-on:change="updateNotifySetting">
                                    <template v-slot:label>
                                        <div>
                                            {{ $t('notifySettingsRequestSupport')|capitalize }}: <strong
                                            :class="save_user_notify_request_support?'success--text':'error--text'">{{$t(save_user_notify_request_support?'on':'off')|capitalize}}</strong>
                                        </div>
                                    </template>
                                </v-switch>
                                <v-switch v-model="notify_request_support_by_skill" v-on:change="updateNotifySetting" v-show="save_user_notify_request_support">
                                    <template v-slot:label>
                                        <div>
                                            {{ $t('notifySettingsRequestSupportBySkill')|capitalize }}: <strong
                                            :class="notify_request_support_by_skill?'success--text':'error--text'">{{$t(notify_request_support_by_skill?'on':'off')|capitalize}}</strong>
                                        </div>
                                    </template>
                                </v-switch>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <div class="chat_view_loading" v-if="loadingDialog">
                <div class="loading_overlay"></div>
                <v-progress-circular indeterminate size="54" color="white"></v-progress-circular>
            </div>
        </v-card>
    </v-container>
</template>

<script>
import BotService from "@/services/bot.service";

export default {
    name: "NotifySetting",
    props: {
        botCode: String,
    },
    data() {
        return {
            save_user_notify_new_message:false,
            save_user_notify_request_support: false,
            notify_request_support_by_skill: false,
            loadingDialog: true
        }
    },
    computed: {},
    methods: {
        loadNotifySetting() {
            this.loadingDialog = true;
            BotService.getBotNotifySetting(this.$route.params.botCode).then(response => {
                this.save_user_notify_new_message = response.data.save_user_notify_new_message === "1";
                this.save_user_notify_request_support = response.data.save_user_notify_request_support === "1";
                this.notify_request_support_by_skill = response.data.notify_request_support_by_skill === "1";
            }).catch(() => {
                this.$AppService.toastError("get notification setting failed.");
                this.save_user_notify_new_message = false;
                this.save_user_notify_request_support = false;
                this.notify_request_support_by_skill = false;
            }).finally(() => {
                this.loadingDialog = false;
            })
        },
        updateNotifySetting() {
            this.loadingDialog = true;
            let data = {
                save_user_notify_new_message: this.save_user_notify_new_message ? "1" : "0",
                save_user_notify_request_support: this.save_user_notify_request_support ? "1" : "0",
                notify_request_support_by_skill: this.notify_request_support_by_skill ? "1" : "0",
            }
            BotService.updateBotNotifySetting(this.$route.params.botCode, data).then(() => {
                this.$AppService.toastSuccess("update notification setting success.");
                this.loadingDialog = false;
            }).catch(() => {
                this.$AppService.toastError("update notification setting failed.");
                this.loadNotifySetting().then(() => {
                    this.loadingDialog = false;
                })
            })
        },
    },
    mounted() {
        if (this.botCode) {
            this.loadNotifySetting();
        }
    },
    watch: {
        botCode() {
            if (this.botCode) {
                this.loadNotifySetting();
            }
        },
    }
}
</script>

<style scoped lang="scss">
    @import "../../components/style/variables.scss";
    .headline {
        color: #FFFFFF;
        font-size: 18px !important;
        line-height: 30px;
    }
    .chat_view_loading {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        z-index: 99999;
        align-items: center;
        text-align: center;
        padding-top: 27%;

        .loading_overlay {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            background-color: black;
            opacity: 0.2;
        }
    }
</style>